import { IAsicData, IGpuData } from 'types/GpuData';
import { osSeriesNames } from './gpuManufacturers';

export const getChipSlug = (chip: IGpuData | IAsicData) => {
  const chipModel = chip.model.replace(/\s+/g, '-');

  const slug: string[] = [chipModel];

  if ('osSeries' in chip) {
    const osSeriesName = osSeriesNames[chip.osSeries?.toLowerCase()];

    osSeriesName && slug.unshift(osSeriesName);
  }

  return slug.join('-').toLowerCase();
};

export const getGpuName = (gpu: IGpuData) =>
  `${osSeriesNames[gpu?.osSeries.toLowerCase()]} ${gpu?.model}`;
